import React, { ReactElement } from 'react';
import Button from '@ramsey-design-system/button';
import { RootState } from '../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { goToPreviousStep } from '../../../store/step';
import Icon from '@ramsey-design-system/icon';
import { ArrowLeftIcon, ArrowRightIcon } from '@ramsey-design-system/icons';

function NavigationButtons(): ReactElement {
  const dispatch = useDispatch();
  const currentStepIndex = useSelector(
    (state: RootState) => state.steps.currentStepIndex
  );

  return (
    <div>
      <hr className="mt-3 text-gray-30 hidden md:block" />
      <div className="pt-5 flex flex-col md:flex-row-reverse justify-between md:pt-2">
        <Button
          type="submit"
          data-testid="next_button"
          fullWidthOnMobile={true}
          className="mb-2 md:mb-0"
        >
          Next
          <Icon icon={ArrowRightIcon} className="ml-2" />
        </Button>
        {currentStepIndex >= 1 && (
          <Button
            appearance="subtle"
            type="button"
            data-testid="back_button"
            fullWidthOnMobile={true}
            onClick={() => dispatch(goToPreviousStep())}
            className="mt-0"
          >
            <Icon icon={ArrowLeftIcon} className="mr-2 md:" />
            Back
          </Button>
        )}
      </div>
    </div>
  );
}
export { NavigationButtons };
